import PrimerGooglePayOptions from "../../../../content/sdk/android/2.x.x/common/settings/_primerSettings/_paymentMethodOptions/googlePayOptions.mdx";
import PrimerKlarnaOptions from "../../../../content/sdk/android/2.x.x/common/settings/_primerSettings/_paymentMethodOptions/klarnaOptions.mdx";
import PrimerStripeOptions from "../../../../content/sdk/android/2.x.x/common/settings/_primerSettings/_paymentMethodOptions/stripeOptions.mdx";
import PrimerThreeDsOptions from "../../../../content/sdk/android/2.x.x/common/settings/_primerSettings/threeDsOptions.mdx";
import * as React from 'react';
export default {
  PrimerGooglePayOptions,
  PrimerKlarnaOptions,
  PrimerStripeOptions,
  PrimerThreeDsOptions,
  React
};